import RemoteFile from "@/helper/RemoteFile";
import { formatLocalTime } from "@/utils/FormateLocalDate";
import { Typography } from "@mui/material"

interface Props {
  pic?: string;
  name?: string;
  time?: string;
}
export const Card: React.FC<Props>= ({pic, name, time}) => {
  return (
    <div className="flex flex-row items-center">
      {pic ? <RemoteFile keyPath={pic || "no pic"} key={name} className="h-[50px] w-[50px] object-cover rounded-full border-2 border-gray-300" /> : <img
        src='/user.png'
        alt='User'
        className="h-[50px] w-[50px] object-cover rounded-full border-2 border-gray-300"
      />}
      <div className="flex flex-col ml-2">
        <Typography sx={{fontSize:'24px', lineHeight:'25px'}}>{name}</Typography>
        <Typography sx={{fontSize:'18px', color:'gray', lineHeight:'25px'}}>{formatLocalTime(time || "")}</Typography>
      </div>
    </div>
  )
}